module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          href: '/'
        },
        {
          text: 'Tryout Members'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Tryout Members")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Tryout Members\n            "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.groups,
      "headers": _vm.headers,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.pageNumber,
      "custom-pagination-per-page": 10
    },
    on: {
      "dblClicked": _vm.goToDetail,
      "changePage": function($event) {
        _vm.pageNumber = $event
      },
      "doSearch": function($event) {
        _vm.query = $event;
        _vm.loadUserData();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83d24b26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_members/components/TryoutMembers.vue
// module id = 2118
// module chunks = 1